import { IS_URL } from "@constants";

export function isURL(value: string): Error | undefined {
  if (!IS_URL.test(value)) {
    return new Error("Invalid URL");
  }
}
